import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ControlService } from '../../library/control.service';
import { RealtimeService } from '../../library/realtime/realtime.service';
import { CallStoreService } from '../../library/call-store/call-store.service';
import { QaiDialogComponent } from '@qai/ui';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
  selector: 'app-call-leave-early',
  templateUrl: './call-leave-early.component.html',
  styleUrls: ['./call-leave-early.component.scss'],
  standalone: false,
})
export class CallLeaveEarlyComponent implements OnChanges, OnDestroy {
  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;
  @Input() open: boolean = false;
  @Input() controlService: ControlService | undefined;
  @Input() realtimeService: RealtimeService | undefined;
  @Input() description: string = '';

  @Output() confirmLeave = new EventEmitter<void>();
  @Output() resume = new EventEmitter<void>();

  constructor(
    private logger: LoggerService,
    private callStore: CallStoreService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      const isOpenNow = changes['open']?.currentValue;
      if (isOpenNow) {
        this.dialogRef?.showModal();
        this.callStore.registerModalOpen();
      } else {
        this.dialogRef?.close();
        this.callStore.registerModalClosed();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.open) {
      this.callStore.registerModalClosed();
    }
  }

  endCall() {
    this.dialogRef?.close();

    if (this.realtimeService) {
      try {
        this.realtimeService.endRealtimeConversation(true, true);
      } catch (error) {
        this.logger.error('[CALL] tavus - Error ending realtime conversation:', error);
      }
    }

    this.confirmLeave.emit();
  }

  onResume() {
    this.dialogRef?.close();

    if (this.realtimeService) {
      try {
        this.realtimeService.cancelEndCallEarly();
      } catch (error) {
        this.logger.error('[CALL] tavus - Error canceling end call early:', error);
      }
    }

    this.resume.emit();
  }
}
